<template>
  <div id="app">
    <audio
      id="audio"
      :src="music"
      loop="loop"
      autoplay="autoplay"
      ref="myMusic"
    ></audio>
    <img
      src="./assets/open.png"
      class="logo rotation"
      @click="isPlay(false)"
      v-if="isShow"
    />
    <img
      src="./assets/close.png"
      class="logo"
      @click="isPlay(true)"
      v-if="!isShow"
    />
    <router-view />
  </div>
</template>

<script>
import wxConfig from "../static/js/share.js";
export default {
  name: "App",
  data() {
    return {
      isShow: true,
      music: "http://cdn.joyoung-ad.com/00music/bgm24.mp3",
    };
  },
  created() {
    this.getWxShare();
  },
  methods: {
    getWxShare() {
      let url = window.location.href.split("#")[0];
      wxConfig.wxConfig({
        title: "“让世界看见湖北”拼图小游戏",
        desc: "畅游灵秀湖北，品读荆风楚韵。",
        link: url,
        imgUrl: "http://lib.news.cn/common/sharelogo.jpg",
      });
    },
    isPlay(flag) {
      this.isShow = flag;
      if (flag) {
        this.$refs.myMusic.play();
      } else {
        this.$refs.myMusic.pause();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.logo {
  width: 2.75rem;
  height: 2.75rem;
  position: fixed;
  top: 1.5rem;
  right: 1.5rem;
  transform: rotate(90deg);
  z-index: 100;
}
.rotation {
  animation: mymusic 2s infinite linear;
}
@keyframes mymusic {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue